import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function FollowButton({ cid, name, size = "sm" }) {
  const qc = useQueryClient();
  const { data: follows = [] } = useQuery({
    queryKey: ["follows"],
    queryFn: async () => (await api.get("/follows")).data,
  });
  const following = follows.includes(cid);

  const mut = useMutation({
    mutationFn: async () =>
      following ? api.delete(`/follows/${cid}`) : api.post(`/follows/${cid}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["follows"] });
      toast.success(following ? `Unfollowed ${name || "artist"}` : `Following ${name || "artist"} — you'll be alerted on new results`);
    },
  });

  return (
    <button
      data-testid={`follow-${cid}`}
      onClick={(e) => { e.stopPropagation(); mut.mutate(); }}
      className={`inline-flex items-center gap-1.5 rounded-md border transition-colors ${
        size === "lg" ? "px-3 py-2 text-sm" : "px-2 py-1 text-xs"
      } ${following ? "border-amber-500/60 bg-amber-500/10 text-amber-400" : "border-slate-700 text-slate-400 hover:border-amber-500/40 hover:text-amber-400"}`}
    >
      <Star className={`w-4 h-4 ${following ? "fill-amber-400" : ""}`} />
      {following ? "Following" : "Follow"}
    </button>
  );
}
